/**
 * WordPress dependencies
 */
import { _x } from '@safe-wordpress/i18n';

/**
 * External dependencies
 */
import type { ConversionAction, ConversionActionType } from '@nab/types';

/**
 * Internal dependencies
 */
import icon from './icon.svg';
import { Edit as edit } from './edit';
import { View as view } from './view';

import type { Attributes } from './types';

export const name = 'nab/time-on-page';

export const settings: ConversionActionType< Attributes > = {
	name,
	category: 'other',
	title: _x( 'Time on Page', 'text', 'nelio-ab-testing' ),
	description: _x(
		'Counts a conversion after a visitor spends some time on a page.',
		'text',
		'nelio-ab-testing'
	),
	icon,

	attributes: {
		value: 20,
	},

	scope: { type: 'test-scope' },

	edit,
	view,
};

// ==========
// TYPESCRIPT
// ==========

declare module '@nab/conversion-actions' {
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore

	function createConversionAction(
		actionType: typeof name,
		attributes: Partial< Attributes >
	): ConversionAction< Attributes >;
}
